(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cw-companion"] && !Shopify.designMode) return;
  try {
    (() => {
  const $ = id => document.getElementById('cwcp-'+id);
  const pet = $('pet'), root = $('dog-root'), head = $('head-position');
  if(!pet || pet.dataset.initialized) return;
  pet.dataset.initialized='true';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover:hover) and (pointer:fine)');
  const parts = Object.fromEntries(['body','chest','tail','rear-far','front-far','rear-near','front-near','eyes-open','eyes-closed','near-ear','tongue','hearts','sleep-marks'].map(id => [id,$(id)]));
  const poses = {
    sit: [84,126,127,108,163,78,0,69,159,91,160,143,160,153,161,0,0,0],
    stand: [81,108,139,108,171,89,-3,62,159,88,160,148,159,166,160,0,0,0],
    stretch: [78,91,141,141,176,136,-9,58,160,87,160,189,161,207,162,.8,0,0],
    down: [86,145,140,145,174,139,-4,64,161,86,162,184,163,206,164,.4,0,0],
    sleep: [86,145,140,145,172,141,-4,64,161,86,162,184,163,206,164,1,0,1],
    cuddle: [84,127,127,109,160,76,-15,69,159,91,160,141,117,153,161,1,1,0],
    curious: [84,126,127,108,164,76,-9,69,159,91,160,143,160,153,161,0,0,0]
  };
  let current = [...poses.sit], state = 'sit', paused = false, hidden = false;
  let queue = [], segment = null, frame = 0, nextTimer = 0, proximityTimer = 0;
  let phase = 0, effect = '', near = false, lastDraw = 0;
  let lastActivity=performance.now(), lastWag=-10000, pointer=null, facing=1, lookFrame=0;
  let lookX=0, lookY=0, targetX=0, targetY=0, bounds=null;
  const sleepAfter=18000;
  const now = () => performance.now();
  const ease = x => x*x*(3-2*x);
  const mix = (a,b,t) => a+(b-a)*t;
  const line = (id,ax,ay,bx,by,bend) => parts[id].setAttribute('d',`M${ax} ${ay}Q${mix(ax,bx,.48)+bend} ${mix(ay,by,.5)} ${bx} ${by}l7 0`);
  function render(p,t=0) {
    const [hx,hy,sx,sy,x,y,r,rfx,rfy,rnx,rny,ffx,ffy,fnx,fny,closed,tongue,sleep] = p;
    const rumpTop = hy - 27, belly = Math.min(166,Math.max(hy,sy)+25);
    parts.body.setAttribute('d',`M${hx-27} ${hy+8}C${hx-39} ${rumpTop} ${hx-4} ${rumpTop-12} ${hx+18} ${rumpTop+7}C${hx+37} ${hy-15} ${sx-15} ${sy-22} ${sx+5} ${sy-23}C${sx+26} ${sy-23} ${sx+30} ${sy+7} ${sx+17} ${sy+20}C${sx-4} ${belly+3} ${hx-4} ${belly+2} ${hx-23} ${hy+27}Q${hx-34} ${hy+20} ${hx-27} ${hy+8}Z`);
    parts.chest.setAttribute('d',`M${sx-6} ${sy-15}Q${x-33} ${y-5} ${x-14} ${y+5}L${x-17} ${y+23}Q${sx+21} ${sy+24} ${sx-1} ${sy+18}Z`);
    line('rear-far',hx+5,hy+18,rfx,rfy,9); line('rear-near',hx-12,hy+19,rnx,rny,-5);
    line('front-far',sx+4,sy+14,ffx,ffy,-4); line('front-near',sx+18,sy+14,fnx,fny,3);
    const wag = (effect==='wag'||effect==='cuddle') ? Math.sin(t/95)*16 : Math.sin(t/450)*1.2;
    const baseX=hx-26,baseY=hy-13;
    parts.tail.setAttribute('d',`M${baseX+3} ${baseY+mix(6,12,sleep)}C${baseX+mix(-23,-27,sleep)} ${baseY+mix(-2,18,sleep)} ${baseX+mix(-22+wag*.6,-30,sleep)} ${baseY+mix(-32,-8,sleep)} ${baseX+mix(-10+wag,-13,sleep)} ${baseY+mix(-44,-16,sleep)}`);
    head.setAttribute('transform',`translate(${x} ${y}) rotate(${r})`);
    parts['near-ear'].setAttribute('transform',`rotate(${effect==='cuddle'?Math.sin(t/160)*5:0})`);
    parts['eyes-open'].setAttribute('opacity',Math.max(0,1-closed*1.4));
    parts['eyes-closed'].setAttribute('opacity',Math.min(1,closed*1.4));
    parts.tongue.setAttribute('opacity',tongue);
    parts.hearts.setAttribute('opacity',effect==='cuddle'?Math.max(0,Math.sin(Math.min(1,t/2400)*Math.PI))*.7:0);
    parts.hearts.setAttribute('transform',`translate(0 ${effect==='cuddle'?-Math.min(8,t/300):0})`);
    parts['sleep-marks'].setAttribute('opacity',sleep*.6);
    root.setAttribute('transform',`translate(0 ${effect==='cuddle'?Math.sin(t/210)*.7:0})`);
  }
  function setState(s) {
    state=s;pet.dataset.state=s;
  }

  function settle() { segment=null;effect='';frame=0;setState(current[17]>.9?'sleep':'sit');render(current,0);plan(); }
  function tick(time) {
    frame=0;if(paused||hidden||document.hidden)return;
    if(!segment) {
      const item=queue.shift();if(!item){settle();return;}
      segment={from:[...current],to:[...poses[item.pose]],start:time,duration:item.ms,effect:item.effect||''};
      effect=segment.effect;phase=time;
    }
    const progress=Math.min(1,(time-segment.start)/segment.duration);
    current=segment.from.map((v,i)=>mix(v,segment.to[i],ease(progress)));
    if(time-lastDraw>=1000/40||progress===1){render(current,time-phase);lastDraw=time;}
    if(progress===1)segment=null;
    frame=requestAnimationFrame(tick);
  }
  function run(items, name, user=false) {
    clearTimeout(nextTimer);clearTimeout(proximityTimer);cancelAnimationFrame(frame);
    segment=null;queue=items.map(x=>({...x}));effect='';setState(name);
    $('head-look').style.transform='';$('pupil').style.transform='';
    if(reduce.matches) {current=[...poses[items.at(-1).pose]];queue=[];render(current);plan();return;}
    if(paused){current=[...poses[items.at(-1).pose]];queue=[];render(current);return;}
    if(!hidden&&!document.hidden){frame=requestAnimationFrame(tick);follow();}
  }
  const sequences={
    sit:[{pose:'sit',ms:750}],
    sleep:[{pose:'down',ms:1300},{pose:'sleep',ms:1500}],
    stretch:[{pose:'stand',ms:650},{pose:'stretch',ms:1200},{pose:'stretch',ms:1800},{pose:'stand',ms:950},{pose:'sit',ms:850}],
    cuddle:[{pose:'curious',ms:400},{pose:'cuddle',ms:600,effect:'cuddle'},{pose:'cuddle',ms:2400,effect:'cuddle'},{pose:'sit',ms:750}],
    wag:[{pose:'stand',ms:600},{pose:'stand',ms:2300,effect:'wag'},{pose:'sit',ms:800}],
    wake:[{pose:'down',ms:650},{pose:'stand',ms:950},{pose:'stretch',ms:1100},{pose:'stretch',ms:650},{pose:'stand',ms:900},{pose:'sit',ms:750}]
  };
  function act(name,user=false) {
    if(hidden)return;const items=sequences[name];if(!items)return;
    run(items,name,user);
  }
  function plan() {
    clearTimeout(nextTimer);
    if(paused||hidden||document.hidden||reduce.matches||state==='sleep')return;
    nextTimer=setTimeout(()=>{
      if(now()-lastActivity>=sleepAfter){targetX=0;targetY=0;follow();act('sleep');}
      else plan();
    },Math.max(100,sleepAfter-(now()-lastActivity)));
  }
  function follow() {
    if(lookFrame||hidden||document.hidden||reduce.matches)return;
    lookFrame=requestAnimationFrame(updateLook);
  }
  function updateLook() {
    lookFrame=0;if(hidden||document.hidden||reduce.matches)return;
    const resting=state==='sleep';
    const tx=resting?0:targetX,ty=resting?0:targetY;
    lookX=mix(lookX,tx,.17);lookY=mix(lookY,ty,.17);
    $('head-look').style.transform=`translate(${lookX*3.5}px,${lookY*3}px) rotate(${lookY*13-lookX*3}deg)`;
    $('pupil').style.transform=`translate(${lookX*2.4}px,${lookY*1.8}px)`;
    if(Math.abs(lookX-tx)+Math.abs(lookY-ty)>.008)follow();
  }
  function activity() {
    lastActivity=now();
    if(state==='sleep'){act('wake',true);}
    else if(!segment&&!queue.length)plan();
  }
  function hide() {
    hidden=true;pet.hidden=true;pet.inert=true;cancelAnimationFrame(frame);frame=0;
    cancelAnimationFrame(lookFrame);lookFrame=0;
    clearTimeout(nextTimer);clearTimeout(proximityTimer);
    try{sessionStorage.setItem('cw-companion-hidden','1');}catch{}
  }
  $('pet-button').addEventListener('click',()=>{const sleeping=state==='sleep';lastActivity=now();act(sleeping?'wake':'cuddle',true);});
  $('pet-close').addEventListener('click',hide);
  document.addEventListener('pointermove',e=>{
    if(!fine.matches||reduce.matches||paused||hidden||e.pointerType!=='mouse')return;
    if(pointer&&Math.hypot(e.clientX-pointer.x,e.clientY-pointer.y)<3)return;
    pointer={x:e.clientX,y:e.clientY};
    bounds=bounds||$('pet-button').getBoundingClientRect();
    const center=bounds.left+bounds.width*.5,dx=e.clientX-center;
    const direction=dx<-18?-1:dx>18?1:facing;
    if(direction!==facing){facing=direction;$('direction').style.transform=`scaleX(${facing})`;pet.dataset.facing=facing===1?'right':'left';}
    const headX=bounds.left+bounds.width*(facing===1?.72:.28);
    const dy=e.clientY-(bounds.top+bounds.height*.43);
    targetX=Math.tanh((e.clientX-headX)*facing/190);
    targetY=Math.tanh(dy/240);
    const close=Math.hypot(e.clientX-headX,dy)<160,entered=close&&!near;
    near=close;activity();follow();
    if(entered&&!segment&&!queue.length&&now()-lastWag>10000){lastWag=now();act('wag');}
  },{passive:true});
  function leave(){near=false;pointer=null;targetX=0;targetY=0;follow();}
  document.documentElement.addEventListener('pointerleave',leave);window.addEventListener('blur',leave);
  window.addEventListener('resize',()=>{bounds=null;},{passive:true});
  window.addEventListener('scroll',()=>{bounds=null;},{passive:true});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&pet.contains(document.activeElement))hide();});
  document.addEventListener('visibilitychange',()=>{
    pet.classList.toggle('document-hidden',document.hidden);
    if(document.hidden){cancelAnimationFrame(frame);cancelAnimationFrame(lookFrame);frame=0;lookFrame=0;clearTimeout(nextTimer);clearTimeout(proximityTimer);}
    else if(!hidden&&!paused){if(now()-lastActivity>=sleepAfter&&state!=='sleep')act('sleep');else if(segment){segment.from=[...current];segment.start=now();frame=requestAnimationFrame(tick);}else if(queue.length)frame=requestAnimationFrame(tick);else plan();follow();}
  });
  reduce.addEventListener('change',()=>act('sit'));
  render(current);setState('sit');
  try{hidden=sessionStorage.getItem('cw-companion-hidden')==='1';}catch{}
  if(!hidden){pet.hidden=false;plan();}
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cw-sunny-pup"] && !Shopify.designMode) return;
  try {
    (() => {
 const pet=document.getElementById('cw-sunny-pup'),guides=document.getElementById('cwgw-guides');
 if(!pet||!guides||pet.dataset.ready)return;
 pet.dataset.ready='true';
 const key='cw-sunny-pup-hidden',reduced=matchMedia('(prefers-reduced-motion: reduce)'),button=pet.querySelector('.cw-pup-dog'),bubble=pet.querySelector('.cw-pup-bubble'),head=pet.querySelector('[data-head]'),eye=pet.querySelector('.pupil'),tongue=pet.querySelector('[data-tongue]'),status=pet.querySelector('.cw-pup-status');
 let dismissed=false,visible=false,inside=false,timer,speechTimer,happyTimer,blinkTimer,frame,index=0,near=false;
 try{dismissed=sessionStorage.getItem(key)==='1'}catch{}
 function speaking(text){clearTimeout(speechTimer);bubble.textContent=text;status.textContent=text;bubble.classList.add('is-speaking');speechTimer=setTimeout(()=>bubble.classList.remove('is-speaking'),2700)}
 function obstructed(){return document.hidden||[...document.querySelectorAll('dialog[open],[aria-modal="true"]')].some(el=>el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden'&&getComputedStyle(el).opacity!=='0')||!!document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')}
 function sync(){const pause=obstructed();pet.classList.toggle('is-paused',pause);pet.inert=!visible||pause;clearTimeout(timer);if(inside&&!visible&&!dismissed&&!pause)timer=setTimeout(appear,4000)}
 function appear(){if(dismissed||visible||!inside||obstructed())return;visible=true;pet.inert=false;pet.classList.add('is-visible');speaking(pet.dataset.welcome);blinkTimer=setInterval(()=>{if(!obstructed()&&!reduced.matches){pet.classList.add('is-blinking');setTimeout(()=>pet.classList.remove('is-blinking'),350)}},5700)}
 const observer=new IntersectionObserver(entries=>{inside=entries[0].isIntersecting;sync()},{threshold:.08});observer.observe(guides);
 function dismiss(){dismissed=true;visible=false;pet.inert=true;pet.classList.remove('is-visible','is-happy','is-sniffing');clearTimeout(timer);clearTimeout(speechTimer);clearTimeout(happyTimer);clearInterval(blinkTimer);cancelAnimationFrame(frame);try{sessionStorage.setItem(key,'1')}catch{}if(pet.contains(document.activeElement)){const target=document.querySelector('.cwgw-actions a');target?.focus({preventScroll:true})}}
 pet.querySelector('.cw-pup-close').addEventListener('click',dismiss);
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&visible)dismiss()});
 document.addEventListener('pointermove',e=>{if(!visible||obstructed()||e.pointerType==='touch'||reduced.matches)return;cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const r=button.getBoundingClientRect(),dx=e.clientX-(r.left+r.width*.25),dy=e.clientY-(r.top+r.height*.5),x=Math.max(-1,Math.min(1,dx/160)),y=Math.max(-1,Math.min(1,dy/140));head.style.transform=`translate(${x*2}px,${y*2}px) rotate(${y*5+x*2}deg)`;eye.style.transform=`translate(${x*2}px,${y*2}px)`;const close=Math.hypot(dx,dy)<55;if(close!==near){near=close;pet.classList.toggle('is-sniffing',close);if(close)speaking(pet.dataset.sniff)}})},{passive:true});
 button.addEventListener('click',()=>{clearTimeout(happyTimer);pet.classList.add('is-happy');tongue.setAttribute('opacity','1');speaking([pet.dataset.one,pet.dataset.two,pet.dataset.three,pet.dataset.four][index++%4]);happyTimer=setTimeout(()=>{pet.classList.remove('is-happy');tongue.setAttribute('opacity','0')},2000)});
 document.addEventListener('visibilitychange',sync);document.addEventListener('focusin',sync);document.addEventListener('focusout',()=>setTimeout(sync,0));
 const overlays=new MutationObserver(sync);overlays.observe(document.body,{attributes:true,attributeFilter:['class']});document.querySelectorAll('dialog,[role="dialog"]').forEach(el=>overlays.observe(el,{attributes:true,attributeFilter:['open','aria-modal','aria-hidden','class','style']}));
 window.addEventListener('pagehide',()=>{clearTimeout(timer);clearInterval(blinkTimer);cancelAnimationFrame(frame)});
 window.addEventListener('pageshow',e=>{if(e.persisted){visible=false;pet.classList.remove('is-visible');sync()}});
})();
  } catch(e) { console.error(e); }
})();

})();
